function hasDocumentsInEveryStage(value: readonly (readonly unknown[])[]): boolean {
	return value.every((stage) => stage.length > 0);
}

export default hasDocumentsInEveryStage;
